import { useState } from 'react';
const getCurrentDecade = (decades, currentYear) => {
    if (!currentYear)
        return undefined;
    const { decadeValue } = currentYear;
    const foundDecade = decades.find(({ value }) => value === decadeValue);
    return foundDecade;
};
const useTimelineNavigation = ({ decades }) => {
    var _a, _b;
    // Determine initial decade and year
    const initialDecade = decades[0];
    const initialYear = initialDecade === null || initialDecade === void 0 ? void 0 : initialDecade.years[0];
    const [currentYear, setCurrentYear] = useState(initialYear);
    const currentDecade = getCurrentDecade(decades, currentYear);
    const currentDecadeYears = (currentDecade === null || currentDecade === void 0 ? void 0 : currentDecade.years) || [];
    const allYears = (_b = (_a = decades === null || decades === void 0 ? void 0 : decades.map(({ years }) => years)) === null || _a === void 0 ? void 0 : _a.flat()) !== null && _b !== void 0 ? _b : [];
    const onSetCurrentYear = (year, reset) => {
        if (reset) {
            setCurrentYear(undefined);
            return;
        }
        if (!year)
            return;
        // Ensure the year exists within the current decade
        const { decadeValue } = year;
        if (decadeValue !== (currentDecade === null || currentDecade === void 0 ? void 0 : currentDecade.value)) {
            const foundDecade = decades.find(({ value }) => value === decadeValue);
            if (!foundDecade)
                return;
            setCurrentYear(year);
            return;
        }
        const foundYear = currentDecadeYears === null || currentDecadeYears === void 0 ? void 0 : currentDecadeYears.find(({ value }) => value === year.value);
        if (foundYear) {
            setCurrentYear(year);
            if (year.gtm.gtmEvent) {
                year.gtm.gtmEvent(year.gtm.gtm);
            }
        }
        else {
            console.warn(`Year ${year.value} is not available in the decade ${currentDecade === null || currentDecade === void 0 ? void 0 : currentDecade.value}`);
        }
    };
    const onSetCurrentDecade = (decade) => {
        if (!decade)
            return;
        // Ensure the decade exists in the availableYears array
        const foundDecade = decades.find(({ value }) => value === (decade === null || decade === void 0 ? void 0 : decade.value));
        if (foundDecade) {
            setCurrentYear(foundDecade === null || foundDecade === void 0 ? void 0 : foundDecade.years[0]); // Automatically select the first year in the decade
            // TODO: single responsiblity, consider moving gtm related logic outside
            if (decade.gtm.gtmEvent) {
                decade.gtm.gtmEvent(decade.gtm.gtm);
            }
        }
        else {
            console.warn(`Decade ${decade} is not available`);
        }
    };
    return {
        currentYear,
        currentDecade,
        currentDecadeYears,
        allYears,
        setCurrentYear: onSetCurrentYear,
        setCurrentDecade: onSetCurrentDecade,
    };
};
export default useTimelineNavigation;
